// src/pages/categoryItem/components/documents/useDocuments.ts
import { useEffect, useState } from "react";
import { DocumentInterface, DocumentLinkInterface } from "../../types/types";
import { EntityType } from "../../types/enums";
import { getApi } from "../../../api/api";

interface DocumentLinkWithDocument extends DocumentLinkInterface {
  document: DocumentInterface;
}

export interface DocumentItem {
  document: DocumentInterface;
  sortOrder: number;
}

export const useDocuments = (entityType: EntityType, entityId?: number) => {
  const [documents, setDocuments] = useState<DocumentItem[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!entityId) return;

    let cancelled = false;

    const load = async () => {
      setLoading(true);
      try {
        const api = getApi();
        const links = await api.getEntityDocumentFileListPublic({
          entityType,
          entityId,
        });

        if (cancelled) return;

        const result = (links as unknown as DocumentLinkWithDocument[])
          .filter((link) => link.document && !link.document.isPrivate)
          .map((link) => ({
            document: link.document,
            sortOrder: link.sortOrder ?? 0,
          }))
          .sort((a, b) => a.sortOrder - b.sortOrder);

        setDocuments(result);
      } catch (err) {
        if (!cancelled) setDocuments([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [entityType, entityId]);

  return { documents, loading };
};
